const bundledVersion = process.env.NEXT_PUBLIC_BUILD_VERSION;

export function landingBuildVersion() {
  if (/^[a-f0-9]{7,40}$/.test(bundledVersion || '')) return bundledVersion;
  return typeof window !== 'undefined' ? window.instantTranscriberDiagnostics?.version || 'release_unknown' : 'development';
}
